//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable implicit-arrow-linebreak */
import {
  mdiMagnify,
  mdiCogOutline,
  mdiCheckboxBlankCircleOutline,
  mdiLink,
  mdiCurrencyUsd,
  mdiLockOpenOutline,
  mdiCellphoneCog,
  mdiInformationOutline,
} from '@mdi/js'
import { computed, ref } from '@vue/composition-api'

export default {
  setup() {
    const knowledgeBaseSearchQuery = ref('')

    const kbContentData = [
      {
        category: 'account-settings',
        icon: mdiCogOutline,
        color: 'primary',
        title: 'Account Settings',
        questions: [
          { question: 'How Secure Is My Password?', slug: 'how-secure-is-my-password' },
          { question: 'Can I Change My Username?', slug: 'can-i-change-my-username' },
          { question: 'Where Can I Upload My Avatar?', slug: 'where-can-i-upload-my-avatar' },
          { question: 'How Do I Change My Timezone?', slug: 'how-do-i-change-my-timezone' },
          { question: 'How Do I Change My Password?', slug: 'how-do-i-change-my-password' },
        ],
      },
      {
        category: 'api-questions',
        icon: mdiLink,
        color: 'success',
        title: 'API Questions',
        questions: [
          { question: 'What Technologies Are Used?', slug: 'what-technologies-are-used' },
          { question: 'What Are The API Limits?', slug: 'what-are-the-api-limits' },
          { question: 'Why Was My Application Rejected?', slug: 'why-was-my-application-rejected' },
          { question: 'Where can I find the documentation?', slug: 'where-can-i-find-the-documentation' },
          { question: 'How Do I Get An API Key?', slug: 'how-do-i-get-an-api-key' },
        ],
      },
      {
        category: 'billing',
        icon: mdiCurrencyUsd,
        color: 'error',
        title: 'Billing',
        questions: [
          { question: 'Can I Contact A Salés Rep?', slug: 'can-i-contact-a-salés-rep' },
          { question: 'Do I Need To Pay VAT?', slug: 'do-i-need-to-pay-vat' },
          { question: 'Can I Get A Refund?', slug: 'can-i-get-a-refund' },
          { question: 'Difference Annual & Monthly Billing', slug: 'difference-annual-monthly-billing' },
          { question: 'What Happens If The Price Increases?', slug: 'what-happens-if-the-price-increases' },
        ],
      },
      {
        category: 'copyright-legal',
        icon: mdiLockOpenOutline,
        color: 'warning',
        title: 'Copyright & Legal',
        questions: [
          { question: 'How Do I Contact Legal?', slug: 'how-do-i-contact-legal' },
          { question: 'Where Are Your Offices Located?', slug: 'where-are-your-offices-located' },
          { question: 'Who Owns The Copyright On Text?', slug: 'who-owns-the-copyright-on-text' },
          { question: 'Our Content Policy', slug: 'our-content-policy' },
          { question: 'How Do I File A DMCA?', slug: 'how-do-i-file-a-dmca' },
        ],
      },
      {
        category: 'mobile-apps',
        icon: mdiCellphoneCog,
        color: 'info',
        title: 'Mobile Apps',
        questions: [
          { question: 'How Do I Download The Android App?', slug: 'how-do-i-download-the-android-app' },
          { question: 'How To Download Our iPad App', slug: 'how-to-download-our-i-pad-app' },
          { question: 'Where Can I Upload My Avatar?', slug: 'where-can-i-upload-my-avatar' },
          { question: 'Can I Use My Android Phone?', slug: 'can-i-use-my-android-phone' },
          { question: 'Is There An iOS App?', slug: 'is-there-an-i-os-app' },
        ],
      },
      {
        category: 'using-knowHow',
        icon: mdiInformationOutline,
        class: 'text--primary',
        title: 'Using KnowHow',
        questions: [
          { question: 'Customization', slug: 'customization' },
          { question: 'Upgrading', slug: 'upgrading' },
          { question: 'Customizing Your Theme', slug: 'customizing-your-theme' },
          { question: 'Upgrading Your Theme', slug: 'upgrading-your-theme' },
        ],
      },
    ]

    const filteredKB = computed(() => {
      const knowledgeBaseSearchQueryLower = knowledgeBaseSearchQuery.value.toLowerCase()

      return kbContentData.filter(
        item =>
          // eslint-disable-next-line operator-linebreak
          item.title.toLowerCase().includes(knowledgeBaseSearchQueryLower) ||
          item.questions.filter(queObj => queObj.question.toLowerCase().includes(knowledgeBaseSearchQueryLower)).length,
      )
    })

    return {
      knowledgeBaseSearchQuery,
      kbContentData,
      filteredKB,
      icons: { mdiMagnify, mdiCheckboxBlankCircleOutline },
    }
  },
}
